var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBouttimeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627,
    height: 525,
    viewBox: "0 0 627 525",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.895,220.74c-0.155,1.13 -4.473,19.527 26.439,15.469c22.849,-2.999 58.415,-22.871 112.111,-36.706c31.46,-8.106 81.201,-14.872 98.969,4.359c5.024,5.437 15.604,27.3 -7.635,40.196c-8.853,4.913 -26.99,7.846 -44.788,14.247c-59.005,21.217 -71.179,51.708 -78.849,70.293c-6.193,15.004 -14.827,41.946 -38.848,57.274c-3.883,2.478 -21.906,15.019 -42.462,8.269c-14.012,-4.601 -21.827,-21.495 -1.146,-52.113c14.405,-21.325 28.45,-38.36 16.35,-43.801c-16.942,-7.617 -49.944,32.267 -89.455,57.935c-27.323,17.75 -43.793,22.074 -52.564,24.814c-2.055,0.642 -12.511,3.064 -17.993,3.661c-4.098,0.446 -37.359,5.34 -61.059,-15.261c-6.293,-5.47 -23.859,-24.887 -10.322,-54.358c0.718,-1.564 8.914,-25.102 51.735,-57.195c26.493,-19.856 60.206,-35.995 71.676,-44.633c21.369,-16.092 10.952,-29.657 -11.259,-23.46c-13.077,3.648 -35.609,17.41 -38.504,19.178c-27.845,17.007 -27.181,17.687 -54.187,35.575c-2.505,1.659 -12.695,7.713 -18.726,9.491c-19.226,5.668 -35.91,0.182 -38.42,-16.32c-3.111,-20.452 20.405,-40.228 23.593,-42.908c37.078,-31.181 129.66,-66.41 180.594,-66.279c17.096,0.044 35.222,2.597 48.115,16.785c16.506,18.163 2.92,39.967 1.017,43.021c-10.293,16.518 -19.56,18.451 -24.382,32.468Zm-35.414,35.319c-11.355,-6.327 -30.926,1.083 -49.417,18.258c-19.485,18.099 -12.115,31.412 6.484,27.928c14.94,-2.798 61.138,-32.979 42.933,-46.187Z",
    fill: "#303d29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBouttimeLogo);
export default __webpack_public_path__ + "static/media/bouttime-logo.fe4f52e2281841c2170aa4819426a4f1.svg";
export { ForwardRef as ReactComponent };